import { v4 as uuidv4 } from 'uuid';
import { Environment } from '../../../../environment';
import axios, { AxiosError } from 'axios';
import { Api } from '../../axiosApi';

export interface IListagemSubGrupoProdutos {
  idsubgrupo: string;
  grupo: string;
  descricao: string;
}
export interface IDetalheSubGrupoProduto {
  idgrupo: string;
  descricao: string;
}
type TComTotalCount = {
  data: IListagemSubGrupoProdutos[];
  totalCount: number;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}
const getAll = async (page = 1, filter = '', limit = Environment.LIMITE_DE_LINHASSMALL): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/subgrupo?page=${page}&limit=${limit}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || limit),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAllList = async (idgrupo = '', filter = '', id = ''): Promise<TComTotalCount | Error> => {
  try {
    if (id != '') {
      const urlRelativa = `/subgrupolist/${id}`;
      const { data, headers } = await Api.get(urlRelativa);
      if (data) {
        return {
          data,
          totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
        };
      }
      return new Error('Erro ao listar os registros.');
    } else if (idgrupo != '') {
      const urlRelativa: string = id === '' ? `/subgrupolist?limit=${Environment.LIMITE_DE_LINHAS}&grupo=${idgrupo}&filter=${filter}` : `/subgrupolist/${id}`;
      const { data, headers } = await Api.get(urlRelativa);
      if (data) {
        return {
          data,
          totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
        };
      }
      return new Error('Erro ao listar os registros.');
    } else {
      return new Error('Erro ao listar os registros.');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getById = async (id: string): Promise<IDetalheSubGrupoProduto | Error> => {
  try {
    const { data } = await Api.get(`/subgrupo/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const create = async (dados: IDetalheSubGrupoProduto): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IDetalheSubGrupoProduto>('/subgrupo', { idsubgrupo: guuid, ...dados });
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, dados: IDetalheSubGrupoProduto): Promise<void | Error> => {
  try {
    await Api.put(`/subgrupo/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/subgrupo/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const SubGrupoProdutoService = {
  getAll,
  getAllList,
  create,
  getById,
  updateById,
  deleteById,
};